import { Download, FileText } from 'lucide-react';

const TYPE_LABELS = {
  transaction_buyer: { label: 'Purchase', color: 'bg-emerald-100 text-emerald-800' },
  transaction_seller_fee: { label: 'Sale fee', color: 'bg-amber-100 text-amber-800' },
  subscription: { label: 'WANTD+', color: 'bg-indigo-100 text-indigo-800' },
  boost: { label: 'Boost', color: 'bg-orange-100 text-orange-800' },
  plus_listing: { label: 'Plus', color: 'bg-sky-100 text-sky-800' },
};

const STATUS_LABELS = {
  paid: { label: 'Paid', color: 'text-emerald-700' },
  refunded: { label: 'Refunded', color: 'text-amber-700' },
  failed: { label: 'Failed', color: 'text-red-700' },
};

function fmtCents(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

function fmtDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

export function BillingRow({ record, onDownload }) {
  const type = TYPE_LABELS[record.type] || { label: record.type, color: 'bg-gray-100 text-gray-800' };
  const status = STATUS_LABELS[record.status] || { label: record.status, color: 'text-gray-700' };

  return (
    <div
      className="flex items-center gap-3 sm:gap-4 p-3 sm:p-4 bg-[var(--theme-card)] border border-[var(--theme-border)] rounded-xl hover:border-[var(--theme-border-hover)] transition-colors"
      data-testid={`billing-row-${record.id}`}
    >
      <div className="hidden sm:flex w-10 h-10 shrink-0 rounded-lg bg-[var(--theme-hover)] items-center justify-center">
        <FileText className="w-5 h-5 text-[var(--theme-text-secondary)]" />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`text-[11px] sm:text-xs font-medium px-2 py-0.5 rounded-full ${type.color}`}>
            {type.label}
          </span>
          <span className="text-[11px] sm:text-xs text-[var(--theme-text-muted)] truncate">
            {record.invoice_number}
          </span>
        </div>
        <div className="mt-1 text-sm text-[var(--theme-text-primary)] font-medium truncate">
          {record.description}
        </div>
        <div className="text-[11px] sm:text-xs text-[var(--theme-text-secondary)]">
          {fmtDate(record.issued_at || record.created_at)}
        </div>
      </div>

      <div className="text-right shrink-0">
        <div className="text-sm font-semibold text-[var(--theme-text-primary)]">
          {fmtCents(record.amount_cents)}
        </div>
        {record.gst_cents > 0 && (
          <div className="text-[11px] sm:text-xs text-[var(--theme-text-muted)]">
            incl. GST {fmtCents(record.gst_cents)}
          </div>
        )}
        <div className={`text-[11px] sm:text-xs font-medium ${status.color}`}>{status.label}</div>
      </div>

      <button
        onClick={() => onDownload(record)}
        disabled={record.status !== 'paid'}
        className="shrink-0 w-9 h-9 rounded-lg bg-[var(--theme-hover)] hover:bg-[var(--theme-border)] flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        title="Download tax invoice PDF"
        data-testid={`billing-download-${record.id}`}
      >
        <Download className="w-4 h-4 text-[var(--theme-text-primary)]" />
      </button>
    </div>
  );
}
